import { createContext, useContext, useReducer } from "react";

import clone from "lodash/clone";

import FnrEnvironment from "Utilities/FnrEnvironment";

import signupsActions from "./actions";
import { devInitialState } from "./state.dev";

// import { convertSignupListItemAmountsToDollars } from "./utils/convertSignupListItemAmountsToDollars";

/*
let initialState123 = {
	navigation: {
		view: 'list', //list, signup, edit
		previous: false,
		user: null,
	},
	signup: {
		listID: null,
		signupList: null,
		userItems: null,
		updatingItem: false,
		wasJustCancelled: false,
		error: null,
		pendingUpdateItem: null,
	},
	edit: {
		signupList: null,
		listID: null,
	}
};
*/

let initialState = {
  view: "list",
  currentSignupList: { signupItems: [], options: {} },
  additionalInfo: false,
  allSignupLists: null,
  editingSignupList: null,
  signupListID: null,
  user: {},
  editMode: false,
  newSignupList: false,
  showingSignupsListHolder: false,
  duplicatingSignup: false,
  duplicateSignupOptions: null,
  defaultVerbs: null,
  allVerbTypes: null,
  showArchivedSignups: false,
  hasArchivedSignups: false,
  showConfetti: 0,
  hasFundIt: false,
  hasSignupPayments: false,
  hasFNP: false,
  hasProfileFields: false,
  hasFamilyRegistration: false,
  canManageSignupPayments: null,
  network: null,
  familyRegistrationConfigurationID: null,
  familyRegistrationPublicUrl: null,
  customRegistrationID: null,
  familyRegistrationIsLive: null,
  canViewFamilyRegistrationAdminPanel: false,
  canEditMembershipStatusOptions: null,
  networkHasFamilyRegistration: null,
  networkHasMembershipStatuses: null,
  networkHasFundIt: null,
  initialDataLoaded: false,
  triggerRespondentRefresh: false,
  memberRespondents: {},
  signupListTemplates: [],
  isSignupEditMode: false,
  currentSignupItem: null,
  needToUpdateSignupLists: false,
};

const blankSignupList = {
  title: "",
  description: "",
  signupListTypeID: 1,
  signupItems: [
    {
      tempID: 1,
      title: "",
      maxSingleUserSlots: 5,
      totalSlots: 20,
      hasSignupCost: false,
      amount: 0,
      costType: "",
    },
    {
      tempID: 2,
      title: "",
      maxSingleUserSlots: 5,
      totalSlots: 20,
      hasSignupCost: false,
      amount: 0,
      costType: "",
    },
    {
      tempID: 3,
      title: "",
      maxSingleUserSlots: 5,
      totalSlots: 20,
      hasSignupCost: false,
      amount: 0,
      costType: "",
    },
  ],
};

const signupsAppReducer = (state, action) => {
  let newState = { ...state };
  const { type, additionalInfo } = action;

  switch (type) {
    case signupsActions.SET_ADDITIONAL_INFO:
      return { ...state, additionalInfo };
    case "Show Signups List Holder":
      newState.showingSignupsListHolder = true;
      return newState;
    case "Hide Signups List Holder":
      newState.showingSignupsListHolder = false;
      return newState;

    case "Remove Current Signup List":
      // Reset all per-signup state. If you add a field to "Set Current Signup List",
      // you must also clear it here — otherwise it leaks between signups.
      newState.currentSignupList = initialState.currentSignupList;
      newState.customRegistrationID = null;
      return newState;

    case "Set Current Signup List": {
      // const signupListConverted = convertSignupListItemAmountsToDollars(
      //   action.signupList
      // );
      newState.currentSignupList = clone(action?.signupList) || {};

      if (action.user) {
        newState.user = action.user;
      }
      if (action.allSignupLists)
        newState.allSignupLists = action.allSignupLists;
      newState.showingSignupsListHolder = false;

      if (action.allSignupListTypes)
        newState.allVerbTypes = action.allSignupListTypes;
      if (action.network) newState.network = action.network;
      if (action.familyRegistrationConfigurationID)
        newState.familyRegistrationConfigurationID =
          action.familyRegistrationConfigurationID;
      if (action.familyRegistrationPublicUrl)
        newState.familyRegistrationPublicUrl =
          action.familyRegistrationPublicUrl;
      if (action.customRegistrationID)
        newState.customRegistrationID = action.customRegistrationID;
      if (action.triggerRespondentRefresh)
        newState.triggerRespondentRefresh = true;

      newState.currentSignupList.hasExistingUnpaidItems =
        action?.hasExistingUnpaidItems;

      return newState;
    }

    case "Update All Signup Lists":
      if (action.allSignupLists)
        newState.allSignupLists = action.allSignupLists;
      return newState;

    case "Other User Signup Updated": {
      if (action.signupList) {
        // const signupListConverted = convertSignupListItemAmountsToDollars(
        //   action.signupList
        // );
        newState.currentSignupList = JSON.parse(
          JSON.stringify(action?.signupList)
        );
      }
      if (action.allSignupLists)
        newState.allSignupLists = action.allSignupLists;
      return newState;
    }

    case "Reset Signups State":
      newState = { ...initialState };
      return newState;

    case "setSignupListsData":
      newState.allSignupLists = action.payload.signupLists;
      newState.defaultVerbs = action.payload.defaultVerbs;
      newState.signupListTemplates = action.payload.signupListTemplates;

      newState.hasArchivedSignups = newState.allSignupLists?.find(
        (signupList) => signupList.signupListStatusID === 4
      );
      newState.canManageSignupPayments = action.payload.canManageSignupPayments;
      newState.hasFundIt = action.payload.hasFundIt;
      newState.hasFNP = action.payload.hasFNP;
      newState.hasSignupPayments = action.payload.hasSignupPayments;
      newState.hasProfileFields = action.payload.hasProfileFields;
      newState.familyRegistrationIsLive =
        action.payload.familyRegistrationIsLive;
      newState.hasFamilyRegistration = action.payload.hasFamilyRegistration;
      newState.canViewFamilyRegistrationAdminPanel =
        action.payload.canViewFamilyRegistrationAdminPanel || false;
      newState.canEditMembershipStatusOptions =
        action.payload.canEditMembershipStatusOptions || false;
      newState.networkHasFamilyRegistration =
        action.payload.networkHasFamilyRegistration || false;
      newState.networkHasMembershipStatuses =
        action.payload.networkHasMembershipStatuses || false;
      newState.networkHasFundIt = action.payload.networkHasFundIt || false;
      newState.initialDataLoaded = true;
      newState.needToUpdateSignupLists = false;
      if (action.payload.user) {
        newState.user = action.payload.user;
      }
      return newState;

    case "Create New Signup":
      newState.signupListID = null;
      newState.currentSignupList = null;
      //newState.editingSignupList = JSON.parse(JSON.stringify(blankSignupList));
      return newState;

    case "Update Edit Signup Info":
      newState.currentSignupList[action.key] = action.value;
      if (action.key === "title") {
        newState.allSignupLists.find(
          ({ ID }) => ID === newState.currentSignupList.ID
        ).title = action.value;
      }
      return newState;

    case "Update Background Color Info":
      newState.currentSignupList.backgroundColor = action.backgroundColor;
      newState.currentSignupList.backgroundColorScheme =
        action.backgroundColorScheme;
      return newState;

    case "Set Media Settings":
      newState.currentSignupList.media = {
        ...newState.currentSignupList?.media,
        ...action.settings,
        type: action.settings?.type || action.settings.mediaType,
      };
      return newState;

    case "Set Media Type": {
      if (!newState.currentSignupList.media) {
        newState.currentSignupList.media = {
          type: action.mediaType,
          photoID: undefined,
          videoUrl: undefined,
        };
      } else {
        newState.currentSignupList.media.type = action.mediaType;
      }
      return newState;
    }

    case "SignupList Item Edited": {
      let findItem = newState.currentSignupList.signupItems.find((item) =>
        action.ID
          ? item.ID.toString() === action.ID.toString()
          : item.tempID.toString() === action.tempID.toString()
      );
      findItem[action.key] = action.value;
      return newState;
    }

    case "updateAllSignupListItems": {
      newState.currentSignupList.signupItems.forEach((item) => {
        item[action.key] = action.value;
      });

      return newState;
    }

    case "replaceAllSignupListItems": {
      newState.currentSignupList.signupItems = action.payload;
      return newState;
    }

    case "Reorder Signuplist Items": {
      newState.currentSignupList.signupItems = [...action.value];
      return newState;
    }

    case "Update Confirmed Signups":
      if (newState.allSignupLists) {
        const refToUpdate = newState.allSignupLists.find(
          (list) => list.ID === Number(action.ID)
        );
        if (refToUpdate) {
          refToUpdate.totalConfirmedSignups = action.value;
        }
      }
      return newState;

    case "Remove an Item From List": {
      // update all signups to have accurate signup count
      const itemRespondentsCount = newState.currentSignupList.signupItems.find(
        (item) => item.ID === action.ID
      ).numberOfRespondents;
      const currentSignupListID = newState.currentSignupList.ID;

      const allSignupLists = newState.allSignupLists.map((item) => {
        if (item.ID === currentSignupListID) {
          item.totalConfirmedSignups =
            item.totalConfirmedSignups - itemRespondentsCount;
        }
        return item;
      });
      newState.allSignupLists = allSignupLists;

      // remove signup item from current signup list
      newState.currentSignupList.signupItems =
        newState.currentSignupList.signupItems.filter((item) =>
          action.ID
            ? !item.ID || item.ID !== action.ID
            : !item.tempID || item.tempID !== action.tempID
        );
      newState.needToUpdateSignupLists = true;
      return newState;
    }

    case "Add Blank Signup Item":
      newState.currentSignupList.signupItems.push(action.signupItem);
      return newState;

    case "Edit Signup List Option":
      newState.currentSignupList.options[action.name] = action.value;
      return newState;

    case "Update Notify Admins":
      newState.currentSignupList.notifyAdmins = action.value;
      return newState;

    case "Duplicate Signup":
      newState.editingSignupList = JSON.parse(
        JSON.stringify(newState.currentSignupList)
      );
      return newState;

    case "Edit Duplicate Signup Option":
      if (newState.duplicateSignupOptions)
        newState.duplicateSignupOptions[action.name] = action.value;
      return newState;

    case "Update Custom Email Confirmation Data":
      if (!newState.currentSignupList) return newState;
      newState.currentSignupList.customEmailConfirmationData = action.data;
      return newState;

    case "Set Default Verbs":
      newState.defaultVerbs = action.verbs;
      return newState;

    case "Set All Signup List Types":
      newState.allVerbTypes = action.types;
      return newState;

    case "Change Status":
      newState.currentSignupList.signupListStatusID = action.status;
      newState.allSignupLists.find(
        (list) => list.ID === Number(action.ID)
      ).signupListStatusID = action.status;

      newState.hasArchivedSignups = newState.allSignupLists.find(
        (signupList) => signupList.signupListStatusID === 4
      );
      newState.showArchivedSignups = newState.hasArchivedSignups
        ? newState.showArchivedSignups
        : false;
      return newState;

    case "toggleShowArchivedSignups":
      newState.showArchivedSignups = !newState.showArchivedSignups;
      return newState;

    case "setShowArchivedSignups":
      newState.showArchivedSignups = action.payload;
      return newState;

    case "Change Signup Type":
      newState.currentSignupList = JSON.parse(
        JSON.stringify(newState.currentSignupList)
      );
      newState.currentSignupList.signupListVerbs = action.newVerbs;
      newState.currentSignupList.signupListTypeID = action.newVerbs.ID;
      return newState;

    case "Update Item Group Link": {
      newState.currentSignupList = updateSignupListItemGroupLink({
        currentSignupList: newState.currentSignupList,
        linkedToGroup: action.linkedToGroup,
        signupItemID: action.signupItemID,
      });
      return newState;
    }

    case "Set Manual Reminders Sent":
      newState.currentSignupList.manualRemindersSent =
        action.manualRemindersSent;
      return newState;

    case "Set Payment Reminders Sent":
      newState.currentSignupList.paymentRemindersSent =
        action.paymentRemindersSent;
      return newState;

    case "showConfetti": {
      if (action.payload) {
        newState.showConfetti = newState.showConfetti + 1;
      }
      return newState;
    }

    case "Update Signup Description": {
      newState.currentSignupList.description = action.value;
      return newState;
    }

    case "Add New Household User": {
      const user = { ...state?.user } || {};
      const { newUser, householdID } = action.payload;
      newState.user = {
        ...user,
        householdID: householdID || 0,
        canSignupHouseholdMembers: true,
      };
      newState.user.household.push({
        userID: newUser.ID,
        fname: newUser.fname,
        lname: newUser.lname,
        wasJustAddedToHH: true,
      });
      newState.triggerRespondentRefresh = true;
      return newState;
    }

    case "setIsSignupEditMode": {
      newState.isSignupEditMode = action.payload;
      return newState;
    }

    case "setCurrentSignupItem": {
      newState.currentSignupItem = action.payload;
      return newState;
    }

    case "Update All Signups Item Available Slots": {
      const allSignupLists = newState.allSignupLists.map((item) => {
        if (item.ID === action.payload.ID) {
          if (
            item.totalAvailableSlots != null &&
            action.payload.additionalAvailableSlots != null
          ) {
            item.totalAvailableSlots =
              item.totalAvailableSlots +
              action.payload.additionalAvailableSlots;
          }
        }
        return item;
      });
      newState.allSignupLists = allSignupLists;
      return newState;
    }

    default:
      return newState;
  }
};

export const SignupsAppState = createContext();

export function SignupsAppStateProvider({ children }) {
  if (FnrEnvironment.shouldUseDevState())
    initialState = { ...initialState, ...devInitialState };
  return (
    <SignupsAppState.Provider
      value={useReducer(signupsAppReducer, initialState)}
    >
      {children}
    </SignupsAppState.Provider>
  );
}

function updateSignupListItemGroupLink({
  currentSignupList,
  linkedToGroup,
  signupItemID,
}) {
  const index = currentSignupList.signupItems.findIndex(
    (item) => item.ID === signupItemID
  );
  currentSignupList.signupItems[index].linkedToGroup = linkedToGroup;
  return currentSignupList;
}

export function useSignups() {
  const context = useContext(SignupsAppState);

  if (!context) {
    throw new Error(
      "useSignups must be used inside a <SignupsAppStateProvider />"
    );
  }

  return context;
}
